// displays an error message for a textfield
import React from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import { classesType, errorTypeType, errorsType } from '../../types';

const styles = () => ({
  error: {
    color: red[700],
    // a rule-guardrail message lists one line per broken rule; every other
    // caller sends a single line, so honouring newlines costs them nothing
    whiteSpace: 'pre-line'
  }
});

const TextFieldErrorMessage = ({ errors, errorType, classes }) => {
  // if errors is provided by edit prompt page
  if (errors && errors[errorType]) {
    return (
      <Typography className={classes.error}>{errors[errorType]}</Typography>
    );
  }
  // // if errors is provided by errors on authentication pages
  // // if errors' errorType matches the errorType provided then
  // // display the error message
  // if (errors && errors.errorType === errorType) {
  //   return <Typography className={classes.error}>{errors.message}</Typography>;
  // }
  return null;
};

TextFieldErrorMessage.propTypes = {
  classes: classesType.isRequired,
  errorType: errorTypeType.isRequired,
  errors: errorsType.isRequired
};

export default withStyles(styles)(TextFieldErrorMessage);
